import { Component, Input, forwardRef, inject } from '@angular/core';
import { FormBuilder, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { portalConst } from '@app/config';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

@Component({
  selector: 'app-upload-image-element',
  templateUrl: './upload-image-element.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => UploadImageElementComponent),
    },
  ],
  standalone: false,
})
export class UploadImageElementComponent {
  @Input() public submitted = false;
  public formBuilder = inject(FormBuilder);
  public preview: string;

  public form = this.formBuilder.group({
    id: undefined,
    hash: undefined,
    nome_arquivo: [undefined, [Validators.required]],
    extensao: [undefined, [Validators.required]],
    file: [undefined, [Validators.required]],
  });

  public config: DropzoneConfigInterface = {
    clickable: true,
    url: `${portalConst.api.usuario}/temp-upload/v1/file`,
    params: {
      savePhoto: true,
      largura: 1200,
      altura: 1200,
      limiteMaximo: true,
      pesoMaximo: 50,
      stringKbMb: 'MB',
    },
    createImageThumbnails: false,
    maxFiles: 1,
    maxFilesize: 50,
    acceptedFiles: '.jpg,.jpeg,.png',
    previewsContainer: false,
  };

  public onUpload(data: any) {
    this.form.patchValue(data);
    this.form.get('nome_arquivo').setValue(data.title);
    this.form.get('extensao').setValue(data.extension);
    this.preview = portalConst.aws.s3Snv + '/temp-upload-files/' + data.file;
    this.onSend();
  }

  public onDelete(): void {
    this.form.reset();
    this.preview = null;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public writeValue(data: any): void {
    if (!!data) {
      this.form.patchValue(data);
      if (!!data.file) {
        if (!data.file.includes('https://')) {
          this.preview = portalConst.aws.s3Snv + '/temp-upload-files/' + data.file;
        } else {
          this.preview = data.file;
        }
      }
    } else {
      this.form.reset();
    }
  }

  private onSend(): void {
    this.onTouched();
    if (this.form.valid) {
      this.onChange(this.form.value);
    } else {
      this.onChange(undefined);
    }
  }

  public onTouched = () => true;
  private onChange = (_: any) => true;
}
